import { render, staticRenderFns } from "./ShipmentForm.vue?vue&type=template&id=55c226cd"
import script from "./ShipmentForm.vue?vue&type=script&lang=js"
export * from "./ShipmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c226cd')) {
      api.createRecord('55c226cd', component.options)
    } else {
      api.reload('55c226cd', component.options)
    }
    module.hot.accept("./ShipmentForm.vue?vue&type=template&id=55c226cd", function () {
      api.rerender('55c226cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Application/Orders/components/ShipmentForm.vue"
export default component.exports